<!-- Captured or Uploaded Image -->
@if(!file() && !imageUrl()) {
<div class="w-40 h-40 rounded border flex items-center justify-center text-gray-400">
    No file uploaded
</div>
} @else {

@if(file()?.type !== 'application/pdf' && !isBlobURL(finalUrl())) {
<div class="rounded border border-gray-0 flex items-center justify-center bg-gray-0">
    <secured-image [src]="finalUrl()" class="rounded border border-gray-0 flex items-center justify-center bg-gray-0"
        [ngClass]="getCalss()" style="border: none; border-radius: 8px;"></secured-image>
</div>
} @else {

<div class="w-40 h-40 rounded flex items-center justify-center bg-gray-0 flex-col">

    @if(isBlobURL(finalUrl())) {
    <a [href]="finalUrl()" target="_blank" rel="noopener noreferrer" class="p-2 text-center m-2"> View
        More</a>
    <div class="w-30 h-30 rounded border border-gray-0 flex items-center justify-center bg-gray-0 flex-col mb-2">
        <iframe [src]="finalUrl()"
            class="w-40 h-40 rounded border border-gray-0 flex items-center justify-center bg-gray-0"
            style="border: none; border-radius: 8px;"></iframe>
    </div>
    } @else {
    <a [href]="getValidPDFURL(finalUrl())" target="_blank" rel="noopener noreferrer" class="p-2 text-center m-2">
        <mat-icon>picture_as_pdf</mat-icon></a>
    <div class="text-[11px]">{{file()?.fileName}}</div>
    }

</div>

}
}